import { useCallback, useMemo } from "react";

import { useLocalStorage } from "@/lib/react-use/use-local-storage";

type CardDisplaySettings = {
	// サブオプション名の表示
	showSubOptionName: boolean;
	// 合計人数の表示
	showGuestTotalNumber: boolean;
	// 色（オプション）ごとにまとめて並べる
	groupByOptionID: boolean;
};

const STORAGE_KEY_PREFIX = "option-pms-card-display-settings";

const getStorageKey = (hotelID: string) => `${STORAGE_KEY_PREFIX}-${hotelID}`;

const DEFAULT_SETTINGS: CardDisplaySettings = {
	showSubOptionName: false,
	showGuestTotalNumber: false,
	groupByOptionID: false,
};

/**
 * オプションPMSタイムラインカードの表示設定を hotelID ごとに localStorage で永続化する
 */
export const useCardDisplaySettingsLocalStorage = (hotelID: string) => {
	const [stored, setStored] = useLocalStorage<CardDisplaySettings>(getStorageKey(hotelID), DEFAULT_SETTINGS);
	// 既存の永続化値に新規フィールドが欠けていてもデフォルトで補う
	const settings = useMemo<CardDisplaySettings>(
		() => ({
			...DEFAULT_SETTINGS,
			...(stored ?? {}),
		}),
		[stored],
	);

	const setShowSubOptionName = useCallback(
		(checked: boolean) => {
			setStored({ ...settings, showSubOptionName: checked });
		},
		[settings, setStored],
	);

	const setShowGuestTotalNumber = useCallback(
		(checked: boolean) => {
			setStored({ ...settings, showGuestTotalNumber: checked });
		},
		[settings, setStored],
	);

	const setGroupByOptionID = useCallback(
		(checked: boolean) => {
			setStored({ ...settings, groupByOptionID: checked });
		},
		[settings, setStored],
	);

	return { settings, setShowSubOptionName, setShowGuestTotalNumber, setGroupByOptionID };
};
